import { render } from "./BlockURL.vue?vue&type=template&id=becef7ea&scoped=true"
import script from "./BlockURL.vue?vue&type=script&lang=js"
export * from "./BlockURL.vue?vue&type=script&lang=js"

import "./BlockURL.vue?vue&type=style&index=0&id=becef7ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-becef7ea"

export default script